import React from 'react';
import { Link } from 'react-router-dom';

/**
 * ServiceCardV2 — card used on the /v2/services grid and in "Related services".
 * Real <Link> element (not a click handler on a non-interactive card).
 * Card is a single interactive anchor to preserve accessibility semantics.
 */
const ServiceCardV2 = ({ service, lang = 'en', ordinal }) => {
  if (!service) return null;
  const readMoreLabel = lang === 'es' ? 'Ver detalle' : 'View details';
  return (
    <Link
      to={`/v2/services/${service.slug}?lang=${lang}`}
      className="iv2-service-card"
      data-testid={`iv2-service-card-${service.slug}`}
      aria-label={`${service.title} — ${readMoreLabel}`}
    >
      {typeof ordinal === 'string' && (
        <span className="iv2-service-card-ordinal" aria-hidden="true">
          {ordinal}
        </span>
      )}
      {service.kicker && (
        <span className="iv2-service-card-kicker">{service.kicker}</span>
      )}
      <h3 className="iv2-service-card-title">{service.title}</h3>
      <p className="iv2-service-card-desc">{service.short_description}</p>
      <span className="iv2-service-card-more" aria-hidden="true">
        {readMoreLabel} →
      </span>
    </Link>
  );
};

export default ServiceCardV2;
